import { Action } from 'redux';
import { TrackOrderUpdate } from '@services/track/types/track-order-update';
import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import SimpleTrack from '@common/types/release/simple-track';
import SimpleArtist from '@common/types/artist/simple-artist';
import { ErrorAction } from '../common/error-action';

export class NewTrack implements Action {
  readonly type = actions.NEW_TRACK;

  constructor(
    public track: Partial<SimpleTrack>,
    public artist: SimpleArtist
  ) {}
}

export class CreateTrack implements LoadingAction {
  readonly type = actions.CREATE_TRACK;
  readonly isLoading = true;

  constructor(public trackId: string, public releaseId: string) {}
}

export class CreateTrackSuccess implements LoadingAction {
  readonly type = actions.CREATE_TRACK_SUCCESS;
  readonly isLoading = false;

  constructor(public track: Partial<SimpleTrack>) {}
}

export class CreateTrackError implements ErrorAction {
  readonly type = actions.CREATE_TRACK_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateTrack implements LoadingAction {
  readonly type = actions.UPDATE_TRACK;
  readonly isLoading = true;
  readonly mainLoader: boolean = false;

  constructor(
    public track: Partial<SimpleTrack>,
    public republish: boolean = false
  ) {
    this.mainLoader = republish;
  }
}

export class UpdateTrackSuccess implements LoadingAction {
  readonly type = actions.UPDATE_TRACK_SUCCESS;
  readonly isLoading = false;

  constructor(
    public track: Partial<SimpleTrack>,
    public republish: boolean = false
  ) {}
}

export class UpdateInvalid implements LoadingAction {
  readonly type = actions.UPDATE_INVALID_FORM;
  readonly isLoading = false;

  constructor(public value: boolean = false) {}
}
export class UpdateTrackError implements ErrorAction {
  readonly type = actions.UPDATE_TRACK_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetTracks implements LoadingAction {
  readonly type = actions.GET_TRACKS;
  readonly isLoading = true;
  readonly mainLoader = true;

  constructor(public releaseId: string) {}
}

export class ListMultipleTracks implements LoadingAction {
  readonly type = actions.LIST_MULTIPLE_TRACKS;
  readonly isLoading = true;

  constructor(public releaseIds: string[]) {}
}

export class GetTracksSuccess implements LoadingAction {
  readonly type = actions.GET_TRACKS_SUCCESS;
  readonly isLoading = false;

  constructor(
    public tracks: Partial<SimpleTrack>[],
    public disableCheck?: boolean
  ) {}
}

export class GetTracksError implements ErrorAction {
  readonly type = actions.GET_TRACKS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateTrackOrder implements LoadingAction {
  readonly type = actions.UPDATE_TRACK_ORDER;
  readonly isLoading = true;

  constructor(
    public orderUpdates: TrackOrderUpdate[],
    public releaseId: string
  ) {}
}

export class UpdateTrackOrderSucess implements LoadingAction {
  readonly type = actions.UPDATE_TRACK_ORDER_SUCCESS;
  readonly isLoading = false;
}

export class UpdateTrackOrderError implements ErrorAction {
  readonly type = actions.UPDATE_TRACK_ORDER_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class UpdateTrackField<T extends keyof SimpleTrack> implements Action {
  readonly type = actions.UPDATE_TRACK_FIELD;

  constructor(
    public trackId: string,
    public field: T,
    public value: SimpleTrack[T]
  ) {}
}

export class UpdateTrackPreview implements Action {
  readonly type = actions.UPDATE_TRACK_PREVIEW;

  constructor(
    public trackId: string,
    public previewStart: number,
    public previewLength: number
  ) {}
}

export class RemoveTrack implements LoadingAction {
  readonly type = actions.REMOVE_TRACK;
  readonly isLoading = true;

  constructor(public releaseId: string, public trackId: string) {}
}

export class RemoveTrackSuccess implements LoadingAction {
  readonly type = actions.REMOVE_TRACK_SUCCESS;
  readonly isLoading = false;
}

export class RemoveTrackError implements ErrorAction {
  readonly type = actions.REMOVE_TRACK_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class DisableReplicateCollaborators implements Action {
  readonly type = actions.DISABLE_REPLICATE_COLLABORATORS;
}

export class ResetTracksStore implements Action {
  readonly type = actions.RESET_TRACKS_STORE;
}

export type TrackActions =
  | NewTrack
  | CreateTrack
  | CreateTrackSuccess
  | CreateTrackError
  | GetTracks
  | GetTracksSuccess
  | GetTracksError
  | UpdateTrackOrder
  | UpdateTrackOrderSucess
  | UpdateTrackOrderError
  | UpdateTrackField<keyof SimpleTrack>
  | UpdateTrackPreview
  | UpdateTrack
  | UpdateTrackSuccess
  | UpdateTrackError
  | UpdateInvalid
  | RemoveTrack
  | RemoveTrackSuccess
  | RemoveTrackError
  | DisableReplicateCollaborators
  | ResetTracksStore;
